module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', [_vm._l((_vm.users_tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': tab.id == _vm.active_tab
      },
      attrs: {
        "href": ("#" + (tab.id))
      },
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_c('label', {
      staticClass: "innerBold"
    }, [_vm._v(_vm._s(tab.title))])])
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "100%",
      "text-align": "right"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_value),
      expression: "search_value"
    }],
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "search users"
    },
    domProps: {
      "value": (_vm.search_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "black",
      "color": "white"
    },
    on: {
      "click": _vm.loadUsers
    }
  }, [_vm._v("Search")])])], 2)])], 2), _vm._v(" "), _c('v-card', {
    staticClass: "bg-natural-grey pt-70 px-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    staticClass: "user-table custom-data-table table-footer",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.users,
      "pagination": _vm.pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_users
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "ml-2 avatar-image-wrapper"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.avatar.url + ')',
          })
        }), _vm._v(" "), _c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.username))])])]), _vm._v(" "), (_vm.active_tab == 'moderator') ? _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-switch', {
          staticClass: "setting-cell-switch",
          attrs: {
            "label": "",
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              _vm.toggleViewDirectMessages(props.item)
            }
          },
          model: {
            value: (props.item.enabled_view_direct_messages),
            callback: function($$v) {
              _vm.$set(props.item, "enabled_view_direct_messages", $$v)
            },
            expression: "props.item.enabled_view_direct_messages"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-switch', {
          staticClass: "setting-cell-switch",
          attrs: {
            "label": "",
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              _vm.toggleLiveVideo(props.item)
            }
          },
          model: {
            value: (props.item.enabled_live_video),
            callback: function($$v) {
              _vm.$set(props.item, "enabled_live_video", $$v)
            },
            expression: "props.item.enabled_live_video"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-switch', {
          staticClass: "setting-cell-switch",
          attrs: {
            "label": "",
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              _vm.toggleLiveVideoFree(props.item)
            }
          },
          model: {
            value: (props.item.enabled_live_video_free),
            callback: function($$v) {
              _vm.$set(props.item, "enabled_live_video_free", $$v)
            },
            expression: "props.item.enabled_live_video_free"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-switch', {
          staticClass: "setting-cell-switch",
          attrs: {
            "label": "",
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              _vm.toggleSignInAuthorized(props.item)
            }
          },
          model: {
            value: (props.item.sign_in_authorized),
            callback: function($$v) {
              _vm.$set(props.item, "sign_in_authorized", $$v)
            },
            expression: "props.item.sign_in_authorized"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(props.item.social_provider != null) ? _c('a', {
          attrs: {
            "href": ("https://" + (props.item.social_provider) + ".com/" + ((props.item.social_user_id == null ? props.item.social_user_name: props.item.social_user_id))),
            "target": "_blank"
          }
        }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(("https://" + (props.item.social_provider) + ".com/" + ((props.item.social_user_id == null ? props.item.social_user_name: props.item.social_user_id)))) + "\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.created_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(props.item.approver) ? _c('router-link', {
          attrs: {
            "to": ("/" + (props.item.approver.slug))
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(props.item.approver.username) + "\n\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-menu', {
          staticClass: "more-menu",
          attrs: {
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "dark": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [(props.item.status == 'inactive') ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.sendConfirmEmail(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Resend confirm email")])])], 1) : _vm._e(), _vm._v(" "), (
          ['suspended', 'pending'].indexOf(props.item.status) !== -1
        ) ? _c('v-list-tile', {
          key: "activate",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.activateAccount(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Activate account")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openUserDeleteConfirmDialog(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Remove account")])])], 1), _vm._v(" "), (
          props.item.status == 'active' && ['listener', 'moderator'].indexOf(props.item.user_type) > -1
        ) ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.updateUserRole(props.item, 'artist')
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Convert to artist")])])], 1) : _vm._e(), _vm._v(" "), (
          props.item.status == 'active' && ['listener', 'moderator'].indexOf(props.item.user_type) > -1
        ) ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.updateUserRole(props.item, 'brand')
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Convert to brand")])])], 1) : _vm._e(), _vm._v(" "), (
          props.item.status == 'active' && ['artist', 'brand', 'moderator'].indexOf(
            props.item.user_type
          ) > -1
        ) ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.updateUserRole(props.item, 'listener')
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Convert to listener")])])], 1) : _vm._e(), _vm._v(" "), (
          props.item.status == 'active' && ['listener', 'artist'].indexOf(props.item.user_type) > -1
        ) ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.updateUserRole(props.item, 'moderator')
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Convert to moderator")])])], 1) : _vm._e(), _vm._v(" "), (props.item.stripe_connected) ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openDisconnectStripeConfirmDialog(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Disconnect Stripe")])])], 1) : _vm._e()], 1)], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_stream_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_stream_delete_confirm_dialog = $$v
      },
      expression: "show_stream_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Stream")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the stream will no longer be available. Click OK to\n\t\t\t\t\tdelete, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.archiveStream()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStreamDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_free_stream_toggle_confirm_dialog),
      callback: function($$v) {
        _vm.show_free_stream_toggle_confirm_dialog = $$v
      },
      expression: "show_free_stream_toggle_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Stream Running")]), _vm._v(" "), _c('v-card-text', [_vm._v("Stream is running for now. Please stop the stream before toggle free\n\t\t\t\t\tstream option")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeFreeStreamToggleConfirmDialog()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_disconnect_stripe_confirm_dialog),
      callback: function($$v) {
        _vm.show_disconnect_stripe_confirm_dialog = $$v
      },
      expression: "show_disconnect_stripe_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Disconnect Stripe")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you going to disconnect this user from Yousound\n\t\t\t\t\tmarketplace?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.disconnectStripe()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDisconnectStripeConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_user_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_user_delete_confirm_dialog = $$v
      },
      expression: "show_user_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm._.get(_vm.user, 'avatar.thumb.url'),
      "height": "125px",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('div', [_vm._v("\n\t\t\t\t\t\tDo you really want to delete\n\t\t\t\t\t\t"), _c('b', [_vm._v(_vm._s(_vm._.get(_vm.user, "display_name", "User")))]), _vm._v("?\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.removeAccount(_vm.user)
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    on: {
      "click": function($event) {
        _vm.closeUserDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68e157fa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/components/users.vue
// module id = 1758
// module chunks = 180